module.exports = __webpack_public_path__ + "static/media/Raccoon Costume Fan.ae860725.jpg";